// extracted by mini-css-extract-plugin
export default {"wrapper":"CostConfig_wrapper__-LXbA","table_text":"CostConfig_table_text__dHVAu","red":"CostConfig_red__JISK1"};